import './RefineByHorizontal.scss';

import { registryComponent } from '@boost-sd/components-registry/registry';
import Button from '@components/Button';
import { InnerHTMLRenderer } from '@components/InnerHTMLRenderer';
import { createClsNameMap } from '@utils';
import { useTranslation } from 'react-i18next';

type RefineByHorizontalProps = {
  hasButton?: boolean;
  onClearAll: () => void;
  onRemove: (filterOptionId: string, value: string) => void;
  refineByData: Array<{
    rawValue: string;
    filterOptionId: string;
    label?: string;
    value?: string;
  }>;
};

export const clsNameMap = createClsNameMap({
  elements: {
    'refine-by': createClsNameMap({}),
    'refine-by-title': createClsNameMap({}),
    'refine-by-heading': createClsNameMap({}),
    'refine-by-list': createClsNameMap({}),
    'refine-by-item': createClsNameMap({}),
    'refine-by-item-clear': createClsNameMap({}),
    'refine-by-type': createClsNameMap({}),
    'refine-by-option': createClsNameMap({}),
    'refine-by-value': createClsNameMap({}),
    'refine-by-clear': createClsNameMap({}),
  },
})('refine-by-horizontal');

const RefineByHorizontal = ({
  hasButton,
  refineByData,
  onRemove,
  onClearAll,
}: RefineByHorizontalProps) => {
  const { t } = useTranslation();

  const refineByList = () => {
    return refineByData?.map(
      ({
        filterOptionId,
        rawValue,
        label,
        value,
      }: {
        rawValue: string;
        filterOptionId: string;
        label?: string | undefined;
        value?: string | undefined;
      }) => {
        if (!label || !value) return <></>;

        return (
          <button
            aria-label={`Clear filter by ${value}`}
            key={`${filterOptionId}-${value}`}
            className={clsNameMap.elm('refine-by-item')}
            onClick={() => onRemove(filterOptionId, rawValue)}
          >
            <span className={clsNameMap.elm('refine-by-type')}>
              <span className={clsNameMap.elm('refine-by-value')}>
                <InnerHTMLRenderer as='span' html={`${value}`} />
              </span>
            </span>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='12'
              height='12'
              viewBox='0 0 12 12'
              fill='none'
              className={clsNameMap.elm('refine-by-clear')}
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.41401 6.00001L11.707 1.70701C12.098 1.31601 12.098 0.684006 11.707 0.293006C11.316 -0.0979941 10.684 -0.0979941 10.293 0.293006L6.00001 4.58601L1.70701 0.293006C1.31601 -0.0979941 0.684006 -0.0979941 0.293006 0.293006C-0.0979941 0.684006 -0.0979941 1.31601 0.293006 1.70701L4.58601 6.00001L0.293006 10.293C-0.0979941 10.684 -0.0979941 11.316 0.293006 11.707C0.488006 11.902 0.744006 12 1.00001 12C1.25601 12 1.51201 11.902 1.70701 11.707L6.00001 7.41401L10.293 11.707C10.488 11.902 10.744 12 11 12C11.256 12 11.512 11.902 11.707 11.707C12.098 11.316 12.098 10.684 11.707 10.293L7.41401 6.00001Z'
                fill='#3D4246'
              />
            </svg>
          </button>
        );
      }
    );
  };

  return (
    <div className={clsNameMap.elm('refine-by')}>
      <div className={clsNameMap.elm('refine-by-title')}>
        <div className={clsNameMap.elm('refine-by-heading')} role='heading' aria-level={2}>
          {t('refine')}
        </div>

        <div className={clsNameMap.elm('refine-by-list')}>{refineByList()}</div>

        {hasButton && (
          <Button
            buttonModifiers={['clear']}
            onClick={onClearAll}
            aria-label={t('Clear all filters')}
          >
            {t('clearAll')}
          </Button>
        )}
      </div>
    </div>
  );
};

export default registryComponent('RefineByHorizontal', RefineByHorizontal);
